import useSlingApi from '@sdk/api/useSlingApi';
import { useMutation } from '@tanstack/react-query';
import { TaskTemplatePayload } from '@sdk/shiftTasks/types/apiTypes';

import { useShiftTasksBridge } from '@web/shiftTasks/ShiftTasksBridgeProvider/ShiftTasksBridgeProvider';
import { mapTaskTemplateAPIToUI } from '@web/shiftTasks/utils/mappers';

export function useAddTaskTemplate() {
  const { shiftTasks } = useSlingApi();
  const shiftTasksBridge = useShiftTasksBridge();

  const mutation = useMutation({
    mutationFn: async (payload: TaskTemplatePayload) => {
      const result = await shiftTasks.addTemplate(payload);
      return mapTaskTemplateAPIToUI(result.data);
    },
    onSuccess: (payload) => {
      shiftTasksBridge.onAddTaskTemplate(payload);
    },
  });

  return mutation;
}
